import React, { useContext, useState } from "react";
import FormDataContext from "./formContext";
import { trackFormSubmit } from "../../../lib/gtag";
import { sendTransactionalEmail } from "../../../services/email";
import { buildApplicationEmail } from "./applicationEmail";

function SubmitPopup() {
  let { submitPopup, setSubmitPopup, setFinishPopup, data } =
    useContext(FormDataContext);
  let [submitting, setSubmitting] = useState(false);
  let [error, setError] = useState(null);

  const handleFormSubmit = async () => {
    setSubmitting(true);
    setError(null);
    try {
      const { subject, htmlContent } = buildApplicationEmail(data);
      await sendTransactionalEmail({
        subject,
        htmlContent,
        ...(data.email ? { replyTo: { email: data.email, name: data.fullName } } : {}),
      });

      trackFormSubmit("recruitment");
      setSubmitPopup(false);
      setFinishPopup(true);
    } catch (err) {
      // Previously this was only logged, so a failed submission looked
      // identical to a successful one — the applicant got no acknowledgement
      // either way.
      setError(
        "We couldn't submit your application. Please try again, or email it to info@terces.io."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      {submitPopup && (
        <div className="popupContainer">
          <div className="popup">
            <span>
              {submitting
                ? "Submitting your application…"
                : "Are you sure do you want to submit form? feel free to revise data first."}
            </span>
            {error && (
              <span className="validationErrorMessage" role="alert">
                {error}
              </span>
            )}
            <div className="popupButtonsContainer">
              <button
                type="button"
                className="secondaryButton"
                disabled={submitting}
                onClick={() => {
                  setError(null);
                  setSubmitPopup(false);
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="primaryButton"
                disabled={submitting}
                onClick={handleFormSubmit}
              >
                {submitting ? "Submitting…" : error ? "Try again" : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default SubmitPopup;
